import Ax from './axios'


// export const GetFaqCount = (data) => {  // FAQ总条数
//   	return Ax.post('Faq/GetFaqTotalCount', {...data}).then(
//     	res => res.data
//   	)
// }

// export const GetRecommend = (data) => {  // Tab推荐
//   	return Ax.post('Faq/GetRecommend', {...data}).then(
//     	res => res.data
//   	)
// }

// export const GetFaqByTag = (data) => {  // Tab标签下具体问题
//   	return Ax.post('Faq/GetFaqByTag', {...data}).then(
//     	res => res.data
//   	)
// }

// export const GetFaqDetail = (data) => {  // 问题详情
//   	return Ax.post('Faq/GetFaqDetail', {...data}).then(
//     	res => res.data
//   	)
// }

export const GetCityMap = (data) => {  // NIO城市列表
    return Ax.post('city/GetCityMap', {...data}).then(
        res => res.data
    )
}


//////////////  新版

export const GetTabTopic = (data) => {  // 主页Tab主题
    return Ax.post('CMS/GetCMSTopic', {...data}).then(
        res => res.data
    )
}

export const GetCMSTopicContent = (data) => {  // 主页下的知识列表
    return Ax.post('CMS/GetCMSTopicContent', {...data}).then(
        res => res.data
    )
}

// export const GetNodeList = (data) => {  // 主页获取知识结构目录
//     return Ax.post('node/GetNodeList', {...data}).then(
//         res => res.data
//     )
// }

export const GetNodeListMap = (data) => {  // 详情获取知识结构目录
    return Ax.post('/node/GetNodeListMapV2', {...data}).then(
        res => res.data
    )
}

export const GetLatestDetail = (data) => {  // 首页知识推荐--最新更新详情
    return Ax.post('/Daily/GetLatestDetail', {...data}).then(
        res => res.data
    )
}

export const SetRead = (data) => {  // 最新更新详情--最新更新设置已读接口
    return Ax.post('/Daily/SetRead', {...data}).then(
        res => res.data
    )
}

export const SetTopicRead = (data) => {
    return Ax.post('/read/setread', {...data}).then(
        res => res.data
    )
}

export const GetServiceConfig = (data) => {
    return Ax.post('/config/all', {
        ...data
    }).then(
        res => res.data
    )
}


// WEBPACK FOOTER //
// ./src/api/home.js